import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import LifeMartStack from "@/pages/LifeMartStack";

export const Route = createFileRoute("/lifemart/stack")({
  head: () => seoHead("/lifemart/stack"),
  component: LifeMartStack,
});
